var public_nurseslounge_lounge_overview = {
    init:function($params){
        var $lounge = JSON.parse(libs.unlock($params));
        var $userId = libs.memoryGet('user_id');
        public_nurseslounge_lounge_overview.information_events();
        public_nurseslounge_lounge_overview.information_location_video($lounge);
        try{
            google.maps.event.addListener(window, "load", public_nurseslounge_lounge_overview.information_location_map($lounge));
        }catch (e) {

        }
        public_nurseslounge_lounge_overview.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        public_nurseslounge_lounge_overview.claim_lounge_container(function($container){
            var $nav = $(".nav-underline");
            var $key = $nav.data('key');
            var $params = {key:$key, user_id:$userId};
            nurseslounge_lounge_overview.claim_lounge($container, $params);
        });
        public_nurseslounge_lounge_overview.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
    },
    information_events:function(){
        $(".nav-underline a:eq(0)").addClass('active');
        var $loungeInformation = $("#nurseslounge-lounge-information");
        var $loungeInformationRight = $loungeInformation.find('.nurseslounge-lounge-information-right');
        var $activityInfo = $loungeInformationRight.find('.activity-info');
        var $discoverMoreDegrees = $loungeInformationRight.find('.discover-more-degrees');
        var $discoverMoreJobs = $loungeInformationRight.find('.discover-more-jobs');
        var $addReview = $loungeInformationRight.find('.add-review');
        var $joinEvent = $loungeInformationRight.find('.join-event');
        var $joinCommunity = $loungeInformationRight.find('.join-community');
        var $nav = $(".nav-underline");
        var $key = $nav.data('key');
        var $params = {key:$key};
        $activityInfo.unbind().click(function(){
            $params = $.extend({}, $params, {id:'activity'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $discoverMoreDegrees.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degrees'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $discoverMoreJobs.unbind().click(function(){
            $params = $.extend({}, $params, {id:'nursingJobs'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $addReview.unbind().click(function(){
            $params = $.extend({}, $params, {id:'ratingReviews'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $joinEvent.unbind().click(function(){
            $params = $.extend({}, $params, {id:'calendar'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $joinCommunity.unbind().click(function(){
            $params = $.extend({}, $params, {id:'followers'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $(".nav-underline a").unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            $params = $.extend({}, $params, {id:$id});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
    },
    login_popup:function($params){
        var $modal = $("#nurseslounge-login-modal");
        var $modalBody = $modal.find('.modal-body');
        public_nurseslounge_lounge_overview.login_request($params, function($chtml){
            $modalBody.html($chtml).promise().done(function(){
                libs.checkImageLoad($($chtml).find('img'), function(){
                    var $backToLogin = $modalBody.find('.back-to-login');
                    $backToLogin.unbind().click(function(){
                        window.location = '/login';
                    });
                    public_nurseslounge_lounge_overview.signup_validate(function($form){
                        $modal.modal('hide');
                        public_nurseslounge_lounge_overview.signup_request(libs.getObjForm($form));
                        $(".form-signup form")[0].reset();
                    });
                    $(".form-signup form .create").unbind().click(function(){
                        $(this).submit();
                    });
                    $modal.modal('show');
                });
            });
        });
    },
    login_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/public/login',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    signup_validate:function(cback){
        var $validator;
        try {
            $validator = $(".form-signup form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $(".form-signup form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){ return $(".form-signup form input[name='email']").val(); }
                        }
                    }
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                password: {
                    required: true,
                    minlength: 8,
                    maxlength: 191
                },
                profile: {
                    required: true
                }
            },
            messages: {
                email: {
                    required: "The email is required",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                password: {
                    required: "The password is required",
                    minlength: "The password must have at least 8 characters",
                    maxlength: "The password cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    signup_request:function($data){
        $.ajax({
            url:"/signup/request",
            method: "POST",
            dataType: "json",
            data:$data,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    var $newWindow = window.open('/login');
                    var $script = document.createElement('script');
                    $script.innerHTML = "var public_nurseslounge_lounge_overview = {" +
                        "openWelcome:function($data){" +
                        "$data = JSON.parse($data);" +
                        "libs.render('/signup/welcome', 'login', 'signup_welcome', $data.data, 'POST') "+
                        "}" +
                        "};public_nurseslounge_lounge_overview.openWelcome('"+JSON.stringify($data)+"');";
                    $newWindow.onload = function(){
                        this.document.body.appendChild($script);
                    };
                }
            }
        });
    },
    information_location_map:function($lounge){
        var $location = $lounge.location;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-lounge-information-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    information_location_video:function($lounge){
        var $nursesloungeLoungeInformation = $("#nurseslounge-lounge-information");
        var $loungeInformationLeft = $nursesloungeLoungeInformation.find('.nurseslounge-lounge-information-left:first');
        var $youtubeVideo = $loungeInformationLeft.find('.youtube-video:first');
        var $myVideo = $loungeInformationLeft.find('.my-video:first');
        var $youtubePlayer;
        var $myPlayer;
        var $vimeoRegex = new RegExp ('(vimeo)','gi');
        var $youtubeRegex = new RegExp ('(youtube)','gi');
        if($lounge.video_url && $lounge.video_url != '' && $lounge.video_url.match($vimeoRegex)){
            var $url = $lounge.video_url.split('/');
            var $vimeoId = $url[$url.length - 1];
            const $vimeoPlayer = new Vimeo.Player($youtubeVideo[0], {
                id:$vimeoId,
                width: 680,
                loop: false,
                autoplay:true,
                muted:true
            });
        }
        if($lounge.video_url && $lounge.video_url != '' && $lounge.video_url.match($youtubeRegex)){
            var $url = new URL($lounge.video_url);
            window.YT.ready(function() {
                $youtubePlayer = new YT.Player($youtubeVideo[0], {
                    height: '360',
                    width: '100%',
                    videoId: $url.searchParams.get('v'),
                    events: {
                        'onReady': function () {
                            $youtubePlayer.mute();
                            $youtubePlayer.playVideo();
                        },
                        'onError': function () {
                            $youtubeVideo.hide();
                        }
                    }
                });
            });
        }
        if($lounge.video_root_lounge && $lounge.name){
            $myVideo.height(480);
            $myPlayer = new Artplayer({
                width: '100%',
                height: '480px',
                destroy:true,
                container: $myVideo[0],
                title: $lounge.name,
                url: $lounge.video_root_lounge,
                mutex: true,
                muted:true,
                play: true,
                controls: [
                    {
                        position: 'right',
                        html: 'Fullscreen',
                        click: function() {
                            public_nurseslounge_lounge_overview.information_location_video_fullscreen($myPlayer, $lounge, true);
                        },
                    },
                ],
                moreVideoAttr: {
                    crossOrigin: 'anonymous'
                }
            }).on('ready', function() {
                $myPlayer.player.pause = true;
                $myPlayer.player.play = true;
            }).on('pause', function(){
                $myPlayer.mask.show = false;
            });
        }
    },
    information_location_video_fullscreen:function($myPlayer, $lounge, $scroll){
        var $gallery;
        var $chtml = '' +
            '<div class="preview-video-container">' +
            '   <div class="video">' +
            '   </div>' +
            '</div>';
        $gallery = new PhotoSwipe($('#nurseslounge-lounge-information-video')[0], PhotoSwipeUI_Default,
            [
                {
                    html: $chtml
                }
            ],
            {
                index: 0,
                clickToCloseNonZoomable: false,
                closeOnScroll: false,
                closeOnVerticalDrag:false,
                closeElClasses: [],
                history:false
            }
        );
        $gallery.init();
        if($myPlayer){
            $myPlayer.player.pause = true;
        }
        var $container = $('#nurseslounge-lounge-information-video .preview-video-container');
        var $target = $container.find('.video:first');
        $target.width($(window).width());
        $target.height($(window).height());
        var $previewPlayer = new Artplayer({
            destroy:true,
            container: $target[0],
            title: $lounge.name,
            url: $lounge.video_root_lounge,
            mutex: true,
            muted:true,
            play: true
        }).on('ready', function() {
            $previewPlayer.player.pause = true;
            $previewPlayer.player.play = true;
            $previewPlayer.mask.show = false;
        }).on('pause', function(){
            $previewPlayer.mask.show = false;
        });
        $previewPlayer.mask.show = false;
        var $fullscreen = false;
        //var $api = $gallery.ui.getFullscreenAPI();
        //$api.enter();
        $("body").css('overflowY', 'hidden');
        $gallery.listen('close', function() {
            if($scroll){
                $("body").css('overflowY', 'scroll');
            }
            $container.remove();
            $previewPlayer.player.pause = true;
            $previewPlayer.destroy();
            if($myPlayer) {
                $myPlayer.player.play = true;
            }
        });
        $gallery.listen('beforeResize', function() {
            if($fullscreen){
                $target.height($(window).height());
            }else{
                $target.height($(window).height());
            }
            $fullscreen = !$fullscreen;
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-lounge-information .nurseslounge-lounge-information-right .banners")
        });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-lounge-information .nurseslounge-lounge-information-right .lounge-ads")
        });
    },
    //Claim Lounge
    claim_lounge_container:function(cback){
        var $container = $("#nurseslounge-lounge-information .nurseslounge-lounge-information-right");
        cback($container);
    }
};
